const DEALER_ID_PATTERN = /^\d{1,18}$/;

export function isValidDealerId(value: string): boolean {
  return DEALER_ID_PATTERN.test(value);
}
